/**
 * Created by spepa on 24.02.2020.
 */

const AdminFBProductsWindow = CleverappsWindow.extend({
    onWindowLoaded: function (adminFBProducts) {
        this.adminFBProducts = adminFBProducts;

        this._super({
            noBackground: true,
            closeButton: false,
            name: "GitInfoWindow",
            content: this.getContent(),
            buttons: this.getButtons()
        });
    },

    getContent: function () {
        const styles = cleverapps.styles.AdminFBProductsWindow;

        const items = [this.createProducts(), this.createLangs(), this.createStandToggle()];
        const content = new cleverapps.Layout(items, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.contentMargin,
            offset: styles.contentOffsetY
        });

        const bg = cleverapps.UI.createScale9Sprite(bundles.admin.frames.lvl_bg);
        bg.setContentSize2(content.width + styles.bg.padding.x, content.height + styles.bg.padding.y);
        bg.addChild(content);
        content.setAlignment(bg.width / 2, bg.height / 2);

        return bg;
    },

    createProducts: function () {
        const productItems = this.productItems = [];
        connector.payments.products.forEach(function (product) {
            productItems.push(this.createOneProduct(product));
        }, this);

        const half = Math.round(productItems.length / 2);
        const columns = [
            new cleverapps.Layout(productItems.slice(0, half), {
                direction: cleverapps.UI.VERTICAL,
                reversed: true
            }),
            new cleverapps.Layout(productItems.slice(half), {
                direction: cleverapps.UI.VERTICAL,
                reversed: true
            })
        ];
        columns.forEach((column) => {
            column.setAnchorPoint(0.5, 1);
        });

        const styles = cleverapps.styles.AdminFBProductsWindow.products;
        const productsNode = new cleverapps.Layout(columns, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.columnsMargin
        });

        const scroll = new cleverapps.UI.ScrollView(productsNode);
        scroll.setContentSize2(styles.width, Math.min(productsNode.height, styles.height));
        scroll.scrollToDefault();

        const frame = new cc.Node();
        frame.setAnchorPoint(0.5, 0.5);
        frame.setContentSize2(scroll.width + styles.framePadding, scroll.height + styles.framePadding);
        frame.addChild(scroll);
        scroll.setAlignment(frame.width / 2, frame.height / 2);

        this.addGroupToggle(frame, this.productItems, false);

        return frame;
    },

    createOneProduct: function (product) {
        const styles = cleverapps.styles.AdminFBProductsWindow.products.product;
        const items = [];

        if (product.image) {
            const imgNode = new cleverapps.Layout.AsyncChild();
            imgNode.setContentSize2(styles.img);
            items.push(imgNode);

            const img = new cc.Sprite(product.image);
            img.addEventListener("load", () => {
                cleverapps.UI.fitToBox(img, styles.img);
                imgNode.reshape(img);
            }, img);
        }

        const title = cleverapps.UI.generateOnlyText(Messages.get(product.title), cleverapps.styles.FONTS.ADMIN_PRODUCTS);
        title.setDimensions(styles.titleWidth, 0);
        title.fitTo(undefined, styles.height);
        items.push(title);

        const id = cleverapps.UI.generateOnlyText(product.itemId, cleverapps.styles.FONTS.ADMIN_PRODUCTS_ID);
        id.setDimensions(styles.idWidth, 0);
        id.setOpacity(160);
        items.push(id);

        const content = new cleverapps.Layout(items, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        });

        const node = new cc.Node();
        node.setAnchorPoint(0.5, 0.5);
        node.setContentSize2(styles);
        content.setAlignment(styles);
        node.addChild(content);
        node.id = product.productId;

        node.selected = false;
        this.makeItemTogglable(node);
        return node;
    },

    createLangs: function () {
        const langItems = cleverapps.config.languages.map(function (lang) {
            return this.createOneLang(lang);
        }, this);
        this.langs = langItems.slice(0);

        const rows = [];
        while (langItems.length > 0) {
            rows.push(new cleverapps.Layout(langItems.splice(0, 6), {
                direction: cleverapps.UI.HORIZONTAL
            }));
            rows.at(-1).setAnchorPoint(0, 0.5);
        }

        const langsNode = new cleverapps.Layout(rows, {
            direction: cleverapps.UI.VERTICAL
        });

        this.addGroupToggle(langsNode, this.langs, true);

        return langsNode;
    },

    createOneLang: function (lang) {
        const styles = cleverapps.styles.AdminFBProductsWindow.langs.lang;
        const text = cleverapps.UI.generateOnlyText(Messages.get(`Language.${lang}`), cleverapps.styles.FONTS.ADMIN_PRODUCTS);
        text.fitTo(styles.width);

        const frame = new cc.Node();
        frame.setAnchorPoint(0.5, 0.5);
        frame.id = lang;
        frame.setContentSize2(styles);
        frame.addChild(text);
        text.setAlignment(frame.width / 2, frame.height / 2);

        frame.selected = true;
        this.makeItemTogglable(frame);

        return frame;
    },

    createStandToggle: function () {
        const text = this.standUpdate = cleverapps.UI.generateOnlyText("Update stand products", cleverapps.styles.FONTS.ADMIN_PRODUCTS);
        text.selected = false;
        this.makeItemTogglable(text);
        return text;
    },

    makeItemTogglable: function (node) {
        const selectedBg = cleverapps.UI.createScale9Sprite(bundles.admin.frames.lvl_selected_bg);
        selectedBg.setOpacity(180);
        selectedBg.setContentSize2(node.width * 1.02, node.height);
        selectedBg.setAlignment(node.width / 2, node.height / 2);
        node.addChild(selectedBg, -1);
        selectedBg.setVisible(node.selected);

        node.toggle = function (state) {
            if (typeof state === "boolean") {
                node.selected = state;
            } else {
                node.selected = !node.selected;
            }

            selectedBg.setVisible(node.selected);
        };

        cleverapps.UI.onClick(node, node.toggle);
    },

    addGroupToggle: function (node, group, defaultVal) {
        const toggle = cleverapps.UI.generateOnlyText("Toggle all", cleverapps.styles.FONTS.GIT_INFO_TEXT);
        toggle.selected = defaultVal;
        node.addChild(toggle);
        toggle.setAnchorPoint(0.5, 0.5);
        toggle.setAlignment(cleverapps.styles.AdminFBProductsWindow.toggle);

        cleverapps.UI.applyHover(toggle);
        cleverapps.UI.onClick(toggle, () => {
            toggle.selected = !toggle.selected;

            group.forEach((product) => {
                product.toggle(toggle.selected);
            }, this);
        });
    },

    getButtons: function () {
        const styles = cleverapps.styles.AdminFBProductsWindow.buttons;
        return [
            new cleverapps.UI.Button({
                type: cleverapps.styles.UI.Button.Images.editor,
                text: "confirm",
                width: styles.width,
                height: styles.height,
                onClicked: function () {
                    const gather = function (group) {
                        return group.filter((item) => item.selected).map((item) => item.id);
                    };

                    const activeLangs = gather(this.langs);
                    const activeProducts = gather(this.productItems);
                    this.adminFBProducts.setUpdateData(activeProducts, activeLangs, this.standUpdate.selected);

                    this.close();
                }.bind(this)
            }),
            new cleverapps.UI.Button({
                type: cleverapps.styles.UI.Button.Images.editor,
                text: "cancel",
                width: styles.width,
                height: styles.height,
                onClicked: this.close.bind(this)
            })
        ];
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    ADMIN_PRODUCTS: {
        size: 20,
        color: cleverapps.styles.COLORS.BLACK
    },

    ADMIN_PRODUCTS_ID: {
        size: 14,
        color: cleverapps.styles.COLORS.BLACK
    }
});

cleverapps.styles.AdminFBProductsWindow = {
    contentMargin: 45,
    contentOffsetY: 100,

    bg: {
        padding: {
            x: 60,
            y: 100
        }
    },

    toggle: {
        x: { align: "center" },
        y: { align: "top", anchor: false, dy: 15 }
    },

    products: {
        columnsMargin: 20,
        height: 650,
        width: 600,
        framePadding: 10,

        product: {
            width: 285,
            height: 40,
            titleWidth: 140,
            idWidth: 100,
            margin: 5,
            x: { align: "left" },
            y: { align: "center" },

            img: {
                width: 36,
                height: 36
            }
        }
    },

    langs: {

        lang: {
            width: 100,
            height: 30
        }
    },

    buttons: {
        width: 150,
        height: 70
    }
};